<template>
  <donut-modal-sections-header title="Enable Gift Cards" />
  <donut-modal-sections-content>
    <div class="f-v">
      <div class="t-xl m-bx2">Enable automatic gift card rewards?</div>
      <div
        v-emoji="exchangeRateMessage"
        class="t m-bx1"
      />
      <div class="t m-bx2">
        Gift cards can be disabled in the Rewards Store Settings.
      </div>
      <div
        v-if="giftCardStatus && giftCardStatus !== 'eligible'"
        class="t warning-yellow m-bx2"
      >
        {{ giftCardStatusCopy[giftCardStatus].description }}
      </div>
    </div>
  </donut-modal-sections-content>
  <donut-modal-sections-actions
    v-if="giftCardStatus && giftCardStatus !== 'eligible'"
    :button-text="giftCardStatusCopy[giftCardStatus].buttonText"
    save-action="rewardsListings/handleGiftCardErrorModal"
    :save-args="{ pointsConfig, error: giftCardStatus }"
  />
  <donut-modal-sections-actions
    v-else
    button-text="Enable Gift Cards"
    save-action="rewardsListings/confirmGiftCardToggle"
    :save-args="{ pointsConfig }"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const { state } = useStore();

const giftCardStatus = computed(() => state.rewardsListings.giftCardStatus);
const dollarsPerPoint = computed(() => state.modal.data.dollarsPerPoint);
const pointsConfig = computed(() => state.modal.data.pointsConfig);

const exchangeRateMessage = computed(() => {
  const centsPerPoint = Math.round(dollarsPerPoint.value * 100);
  return `This will allow employees to redeem gift cards with an exchange rate ${centsPerPoint}¢ = 1 ${pointsConfig.value.points_name} :${pointsConfig.value.emoji}:.`;
});

const giftCardStatusCopy = {
  upgrade_required: {
    // upgrade_required should not reachable in this modal, because gift-card-toggle uses
    // an upgrade modal in that case instead of this modal.
    // Direct to /billing
    description: 'Please upgrade to a paid plan to use gift cards.',
    buttonText: 'View Plans',
  },
  finish_trial: {
    // open intercom chat
    description: 'Gift cards are not available on a free trial. For questions please contact support.',
    buttonText: 'Contact Support',
  },
  blocked: {
    // open intercom chat
    description: 'Gift cards are not available. For questions please contact support.',
    buttonText: 'Contact Support',
  },
  invoiced: {
    description:
      'Please contact your account manager to enable gift cards for invoiced accounts.',
    buttonText: 'Get Started',
  },
};
</script>
